import { render } from "./ImageCollage.vue?vue&type=template&id=ca1d72de&scoped=true"
import script from "./ImageCollage.vue?vue&type=script&lang=js"
export * from "./ImageCollage.vue?vue&type=script&lang=js"

import "./ImageCollage.vue?vue&type=style&index=0&id=ca1d72de&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca1d72de"]])

export default __exports__